import { observable, action } from "mobx";
import { PersistentStore } from "./PersistentStore"


const maxRecentFiles: number = 25;

class RecentFilesDataStoreImpl extends PersistentStore {

	constructor() {
		super("recentFiles");
		this.loadAsync();
	}

	@observable fileIds: string[] = [];

	@action public addToRecentFiles(fileId: string): void {
		if (this.fileIds.length > 0 && this.fileIds[0] === fileId) {
			return;
		}
		let temp: string[] = [];
		temp.push(fileId);
		for (let i = 0; i < this.fileIds.length && temp.length < maxRecentFiles; i++) {
			let id = this.fileIds[i];
			if (id !== fileId) {
				temp.push(id);
			}
		}
		this.fileIds = temp;
	}
}

export var RecentFilesDataStore = new RecentFilesDataStoreImpl();